module.exports = __webpack_public_path__ + "img/labels.203ca48c.webp";